import { render, staticRenderFns } from "./agreementListModal.vue?vue&type=template&id=2b8b6f91&scoped=true&"
import script from "./agreementListModal.vue?vue&type=script&lang=js&"
export * from "./agreementListModal.vue?vue&type=script&lang=js&"
import style0 from "./agreementListModal.vue?vue&type=style&index=0&id=2b8b6f91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b6f91",
  null
  
)

export default component.exports